export default class WelcomeBubble {
  private wrapper: HTMLElement;
  private active = false;

  bindings() {

    if(this.wrapper) {
      if (this.wrapper.classList.contains('js-m-welcome-bubble--delayed')) {
        setTimeout(() => {
          this.toggleState();
        }, 7000);

        setTimeout(() => {
          this.toggleState();
        }, 12000);
      } else {
        this.toggleState();

        setTimeout(() => {
          this.toggleState();
        }, 5000);
      }

      if (this.wrapper.dataset.currentuser) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'login',
          user: {
            email: this.wrapper.dataset.currentuser
          }
        });
      }
    }
  }

  toggleState() {
    this.wrapper.classList.toggle('is-active', this.active = !this.active);
  }

  cache() {
    this.wrapper =  document.querySelector<HTMLElement>('.js-m-welcome-bubble')!;
  }

  init() {
    this.cache();
    this.bindings();
  }
}
